import { HttpApiService } from "@/shared/services/httpApi.service";

import type { SessionEntity } from "../types/sessions.types";

const BASE = "/auth/sessions";

export const sessionsService = {
  list: async (): Promise<SessionEntity[]> => {
    const response = await HttpApiService.get<SessionEntity[]>(BASE);
    return response.data;
  },

  revoke: async (id: string): Promise<void> => {
    await HttpApiService.delete(`${BASE}/${id}`);
  },

  revokeOthers: async (): Promise<{ revoked_count: number }> => {
    const response = await HttpApiService.post<{ revoked_count: number }>(`${BASE}/revoke-others`, {});
    return response.data;
  },
};
